(function() {
	'use strict';

	angular
		.module('app.setup')
		.service('projectSavingsCategoryService', projectSavingsCategoryService);

	projectSavingsCategoryService.$inject = ['$http', 'URLS'];

	function projectSavingsCategoryService($http, URLS) {
		var service = {
			getProjectSavingsCategories: getProjectSavingCategories,
			addProjectSavingsCategory: addProjectSavingsCategory,
			updateProjectSavingsCategory: updateProjectSavingsCategory,
			deleteProjectSavingsCategory: deleteProjectSavingsCategory
		};
		return service;

		function getProjectSavingCategories(customerId) {
			var projectSavingsCategoryCrudUrl = URLS.host + String.format(URLS.projectSavingsCategoryCrud, customerId || globalConfig.customer.id);
			return $http.get(projectSavingsCategoryCrudUrl)
				.then(getProjectSavingsCategoriesSuccess, handleError);

			function getProjectSavingsCategoriesSuccess(response) {
				return response.data;
			}
		}

		function addProjectSavingsCategory(projectSavingsCategory, customerId) {
			var projectSavingsCategoryCrudUrl = URLS.host + String.format(URLS.projectSavingsCategoryCrud, customerId || globalConfig.customer.id);

			return $http.post(projectSavingsCategoryCrudUrl, projectSavingsCategory)
				.then(addProjectSavingsCategorySuccess, handleError);

			function addProjectSavingsCategorySuccess(response) {
				return 'Savings Category created successfully';
			}
		}

		function updateProjectSavingsCategory(projectSavingsCategory, lastModified, customerId) {
			var projectSavingsCategoryCrudUrl = URLS.host + String.format(URLS.projectSavingsCategoryCrud, customerId || globalConfig.customer.id);
			return $http.put(projectSavingsCategoryCrudUrl + '/' + projectSavingsCategory.id, projectSavingsCategory, { headers: { 'If-Unmodified-Since': lastModified } })
				.then(updateProjectSavingsCategorySuccess, handleError);

			function updateProjectSavingsCategorySuccess(response) {
				return response;
			}
		}

		function deleteProjectSavingsCategory(projectSavingsCategoryId, customerId) {
			var projectSavingsCategoryCrudUrl = URLS.host + String.format(URLS.projectSavingsCategoryCrud, customerId || globalConfig.customer.id)+ '/' + projectSavingsCategoryId;
			return $http.delete(projectSavingsCategoryCrudUrl)
				.then(deleteProjectSavingsCategorySuccess, handleError);

			function deleteProjectSavingsCategorySuccess(response) {
				return 'Savings Category deleted successfully';
			}
		}

		function handleError (error) {
			if (error.status === 403) {
				return '';
			} else if (error.status === 412 || error.status === 409) {
				return error.data.error;
			}
			return 'Unknown server error';
		}
	}
})();
